export class HierarchyDropdownItemModel {
  public id;
  public value;
  public parentId;
  public text;
  public isParent;
  public model;
  public children;

  constructor(itemModel, modelPropertyNameDescriptor) {
    this.id = itemModel[modelPropertyNameDescriptor.idPropertyName];
    this.value = itemModel[modelPropertyNameDescriptor.valuePropertyName];
    this.parentId = itemModel[modelPropertyNameDescriptor.parentIdPropertyName];
    this.text = itemModel[modelPropertyNameDescriptor.textPropertyName] || '';
    this.isParent = !!itemModel[modelPropertyNameDescriptor.isParentItemPropertyName];
    this.model = itemModel;
  }

  setAsParentItem(): void {
    this.isParent = true;
  }

  addChild(childItem: HierarchyDropdownItemModel): void {
    if (!this.isParent) {
      throw new Error('Cannot add child to a non parent item');
    }

    this.children = this.children || [];

    this.children.push(childItem);
  }
}
